import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import { ElementoPrimarioConsolidadoService } from "../../../services/ElementoPrimarioConsolidadoService";
import { SnackBarModule } from "../../../modules/SnackBarModule";

export default {
    name: "VisualizarElementoPrimarioConsolidado",
    components: {
        Breadcrumb
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Elementos Primários',
                disabled: false,
                href: '#',
            },
            {
                text: 'Gerenciar Elementos Primários',
                disabled: false,
                href: '/gerenciar-elementos-primarios-consolidados',
            },
            {
                text: 'Visualizar',
                disabled: true
            }
        ],
        elementoPrimario: {},
        loading: false,
        empenhosAlocados: [],
        dotacoesAlocadas: [],
        loadingEmpenhos: false,
        loadingDotacoes: false,
        headersEmpenhos: [
            { text: 'Unidade - Empenho/Ano', value: 'empenho_info', sortable: true },
            { text: 'Valor Alocado (R$)', value: 'valor_alocado', sortable: true, align: 'end' }
        ],
        headersDotacoes: [
            { text: 'Unidade - Dotação/Ano', value: 'dotacao_info', sortable: true },
            { text: 'Valor Alocado (R$)', value: 'valor_alocado', sortable: true, align: 'end' }
        ]
    }),
    created() {
        this.carregarDados();
        this.carregarAlocacoes();
    },
    methods: {
        async carregarDados() {
            const tipo = this.$route.params.tipo;
            const id = this.$route.params.id;

            if (!tipo || !id) {
                SnackBarModule('Parâmetros inválidos para visualização.', 'error');
                this.$router.push('/gerenciar-elementos-primarios-consolidados');
                return;
            }

            try {
                this.loading = true;
                const response = await ElementoPrimarioConsolidadoService.show(tipo, id);

                if (response && !response.error && response.data) {
                    this.elementoPrimario = response.data;
                } else {
                    SnackBarModule('Elemento primário não encontrado.', 'error');
                    this.$router.push('/gerenciar-elementos-primarios-consolidados');
                }
            } catch (error) {
                console.error('Erro ao carregar elemento primário:', error);
                SnackBarModule('Erro ao carregar elemento primário.', 'error');
                this.$router.push('/gerenciar-elementos-primarios-consolidados');
            } finally {
                this.loading = false;
            }
        },
        goBack() {
            this.$router.push('/gerenciar-elementos-primarios-consolidados');
        },
        formatCurrency(value) {
            if (!value && value !== 0) {
                return '-';
            }
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },
        getTipoEpColor(tipo) {
            const colors = {
                'Genérico': '#9C27B0',
                'Emenda Estadual': '#2196F3',
                'Emenda Federal': '#4CAF50',
                'Convênio Federal': '#9C27B0'
            };
            return colors[tipo] || '#757575';
        },
        async carregarAlocacoes() {
            const tipo = this.$route.params.tipo;
            const id = this.$route.params.id;

            if (!tipo || !id) {
                return;
            }

            await Promise.all([
                this.carregarEmpenhosAlocados(tipo, id),
                this.carregarDotacoesAlocadas(tipo, id)
            ]);
        },
        async carregarEmpenhosAlocados(tipo, id) {
            try {
                this.loadingEmpenhos = true;
                const response = await ElementoPrimarioConsolidadoService.getEmpenhosAlocados(tipo, id);
                
                if (!response.error && response.data) {
                    this.empenhosAlocados = response.data.map(item => ({
                        ...item,
                        empenho_info: `${item.unidade || 'N/A'} - ${item.num_empenho || 'N/A'}/${item.ano_empenho || 'N/A'}`
                    }));
                } else {
                    this.empenhosAlocados = [];
                }
            } catch (error) {
                this.empenhosAlocados = [];
            } finally {
                this.loadingEmpenhos = false;
            }
        },
        async carregarDotacoesAlocadas(tipo, id) {
            try {
                this.loadingDotacoes = true;
                const response = await ElementoPrimarioConsolidadoService.getDotacoesAlocadas(tipo, id);
                
                if (!response.error && response.data) {
                    this.dotacoesAlocadas = response.data.map(item => ({
                        ...item,
                        dotacao_info: `${item.unidade || 'N/A'} - ${item.codigo || 'N/A'}/${item.ano || 'N/A'}`
                    }));
                } else {
                    this.dotacoesAlocadas = [];
                }
            } catch (error) {
                this.dotacoesAlocadas = [];
            } finally {
                this.loadingDotacoes = false;
            }
        }
    }
};

